import {convert_date_for_ios} from '../components/ios';
import {thirdparty} from '../components/thirdparty';

export default {

  renderOpeningHour() {
    let currentDate = new Date();
    let currentTime = ('0' + (currentDate.getHours())).slice(-2) + ':' + ('0' + (currentDate.getMinutes())).slice(-2);

    let currentDateTomorrow = new Date();
    let currentDateAfterTomorrow = new Date();

    currentDateTomorrow.setDate(currentDateTomorrow.getDate() + 1);
    currentDateAfterTomorrow.setDate(currentDateAfterTomorrow.getDate() + 2);

    let emergencyService = false

    if ($('.pharmacy-part-emergency-service').length > 0) {
      let emergencyEndDateText = '';
      let emergency_service_start = false;
      let emergency_service_end = false;

      $('.pharmacy-part-emergency-service').find('.emergency-service').each(function () {
        let emergencyServiceStartDate = convert_date_for_ios($(this).data('emergency-service-start'));
        let emergencyServiceEndDate = convert_date_for_ios($(this).data('emergency-service-end'));
        if (emergencyServiceStartDate.getTime() <= currentDate.getTime() && emergencyServiceEndDate.getTime() >= currentDate.getTime()) {
          emergency_service_start = emergencyServiceStartDate;
          emergency_service_end = emergencyServiceEndDate;
          return false;
        }
      });

      if (emergency_service_start != false && emergency_service_end != false) {
        let emergencyEndDate = emergency_service_end;
        let emergencyEndMonth = ('0' + (emergency_service_end.getMonth() + 1)).slice(-2);
        let emergencyEndDay = ('0' + (emergency_service_end.getDate())).slice(-2);
        let emergencyText = emergencyEndDay + '.' + emergencyEndMonth;

        if (emergencyEndDate.getFullYear() == currentDate.getFullYear() && emergencyEndDate.getMonth() == currentDate.getMonth() && emergencyEndDate.getDate() == currentDate.getDate()) {
          emergencyText = 'heute';
        } else if (emergencyEndDate.getFullYear() == currentDateTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateTomorrow.getDate()) {
          emergencyText = 'morgen';
        } else if (emergencyEndDate.getFullYear() == currentDateAfterTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateAfterTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateAfterTomorrow.getDate()) {
          emergencyText = 'übermorgen';
        }

        emergencyEndDateText = (emergencyText + ' ' + ('0' + (emergencyEndDate.getHours())).slice(-2) + ':' + ('0' + (emergencyEndDate.getMinutes())).slice(-2));
        emergencyService = true;

        $('.pharmacy-opening-hours').addClass('text-green').html('Geöffnet bis ' + emergencyEndDateText + ' Uhr (Notdienst)');
      }
    }

    if (!emergencyService) {
      let currentDay = currentDate.toLocaleString('en-us', {weekday: 'long'}).toLowerCase();
      currentDay = currentDay.replace(/[^a-zA-Z ]/g, '');

      let $openingHours = $('.data-opening-hours');
      let begin_1 = $openingHours.find('.' + currentDay).data('begin-1');
      let end_1 = $openingHours.find('.' + currentDay).data('end-1');
      let begin_2 = $openingHours.find('.' + currentDay).data('begin-2');
      let end_2 = $openingHours.find('.' + currentDay).data('end-2');

      if ((begin_1 != '' && end_1 != '' && currentTime >= begin_1 && currentTime <= end_1)) {
        $('.pharmacy-opening-hours').addClass('text-green').html('Geöffnet bis ' + end_1 + ' Uhr');
      } else if ((begin_2 != '' && end_2 != '' && currentTime >= begin_2 && currentTime <= end_2)) {
        $('.pharmacy-opening-hours').addClass('text-green').html('Geöffnet bis ' + end_2 + ' Uhr');
      } else {
        $('.pharmacy-opening-hours').addClass('text-red').html('Aktuell geschlossen');
      }
    }
  },

  init() {
    this.renderOpeningHour();

    // Google Map Static
    if ($('#pharmacy-map-static').length > 0) {
      if (thirdparty()) {
        const staticContainer = $('#pharmacy-map-static');
        const mapUrl = 'https://maps.googleapis.com/maps/api/staticmap';
        let mapData = {
          lat: parseFloat(staticContainer.data('lat')),
          lng: parseFloat(staticContainer.data('lng')),
          marker: staticContainer.data('marker'),
        };

        let href = '';
        if(staticContainer.data('href').length > 0){
          href = '<a href="' + staticContainer.data('href') + '" target="_blank" rel="nofollow" class="stretched-link stretched-link-hidden">Route</a>';
        }

        let picture = $('<picture>' +
          '<source srcSet="' + mapUrl + '?center=' + mapData.lat + ',' + mapData.lng + '&zoom=14&size=1110x275&key=' + mea.gmaps_api_key + '&markers=icon:' + mapData.marker + '|' + mapData.lat + ',' + mapData.lng + '" media="(min-width: 992px)">' +
          '<source srcSet="' + mapUrl + '?center=' + mapData.lat + ',' + mapData.lng + '&zoom=14&size=930x275&scale=2&key=' + mea.gmaps_api_key + '&markers=icon:' + mapData.marker + '|' + mapData.lat + ',' + mapData.lng + ' 2x" media="(min-width: 768px)">' +
          '<source srcSet="' + mapUrl + '?center=' + mapData.lat + ',' + mapData.lng + '&zoom=14&size=690x275&scale=2&key=' + mea.gmaps_api_key + '&markers=icon:' + mapData.marker + '|' + mapData.lat + ',' + mapData.lng + ' 2x" media="(min-width: 576px)">' +
          '<source srcSet="' + mapUrl + '?center=' + mapData.lat + ',' + mapData.lng + '&zoom=14&size=526x215&scale=2&key=' + mea.gmaps_api_key + '&markers=icon:' + mapData.marker + '|' + mapData.lat + ',' + mapData.lng + ' 2x">' +
          '<img src="' + mapUrl + '?center=' + mapData.lat + ',' + mapData.lng + '&zoom=14&size=526x215&key=' + mea.gmaps_api_key + '&markers=icon:' + mapData.marker + '|' + mapData.lat + ',' + mapData.lng + '" class="img-fluid" title="Map" alt="Map" />' +
          '</picture>' + href);

        staticContainer.prepend(picture);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/landingpage-servicefeatures.js